import React from 'react'
import TabsProvider from '../tabs-provider'

const ShowCurriculumTypes = ({ location, children }) => (
  <div>
    <TabsProvider
      pathname={location.pathname}
      tabs={[{
        label: 'Curriculums',
        path: '/events/curriculums'
      }, {
        label: 'Core Curriculum',
        path: '/events/core-curriculum'
      }]}
    />
    {children}
  </div>
)

export default ShowCurriculumTypes
